export const LEAVE_TYPE="LEAVE_TYPE";
export const LEAVE_BALANCE="LEAVE_BALANCE";
export const LEAVE_LIST="LEAVE_LIST";
export const CREATE_LEAVE="CREATE_LEAVE";
export const LEAVE_APPROVE_LIST="LEAVE_APPROVE_LIST";
export const LEAVE_APPROVE="LEAVE_APPROVE";
export const LEAVE_APPROVE_LIST_DATEWISE="LEAVE_APPROVE_LIST_DATEWISE";
export const LEAVE_CANCEL="LEAVE_CANCEL";
export const LEAVE_BALANCE_ALL="LEAVE_BALANCE_ALL";
export const ADD_LEAVE_BALANCE="ADD_LEAVE_BALANCE";
export const LEAVE_BALANCE_LIST="LEAVE_BALANCE_LIST";
export const LEAVE_APPROVED_LIST_BY_ID_YEAR = "LEAVE_APPROVED_LIST_BY_ID_YEAR";
export const LEAVE_LIST_BY_YEAR = "LEAVE_LIST_BY_YEAR";
export const LEAVE_SUMMARY = "LEAVE_SUMMARY";
export const CREATE_PASSOUT="CREATE_PASSOUT";
export const PASSOUT_SUMMARY="PASSOUT_SUMMARY";
export const PASSOUT_DETAILS="PASSOUT_DETAILS";
export const LEAVE_DETAILS="LEAVE_DETAILS";
export const BULK_APPROVE_LEAVE="BULK_APPROVE_LEAVE";
export const BULK_APPROVE_PASSOUTS="BULK_APPROVE_PASSOUTS";











